import { createFileRoute } from "@tanstack/react-router";
import AgenteRetailIA from "@/pages/AgenteRetailIA";
import { SITE_URL } from "@/lib/site-url";

/** Página explicativa del Agente Retail IA (ES). La ventana de consulta vive en /agente-retail-ia. */
export const Route = createFileRoute("/que-es-el-agente-retail-ia")({
  head: () => {
    const title = "Agente Retail IA para comercios a pie de calle | Retail Lemon";
    const description =
      "Qué es el Agente Retail IA: acompaña a tu tienda, bar o local a pie de calle con guías, hoja de ruta y las subvenciones de tu local. No es un chat genérico: sigue el paso de tu negocio.";
    const url = `${SITE_URL}/que-es-el-agente-retail-ia`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "es_ES" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
    };
  },
  component: () => <AgenteRetailIA routeLang="es" />,
});
